import { render, staticRenderFns } from "./BuildingDetailView.vue?vue&type=template&id=2b7f12fc"
import script from "./BuildingDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildingDetailView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports